import { useHistory } from 'react-router-dom';
import { List } from 'antd';
import withAuthenticator from 'HOCs/withAuthenticator';
import { BiGroup, BiChevronRight } from 'react-icons/bi';
import { query } from 'helpers/QueryHelper';

import { useQuery } from 'react-query';

const randomColors = ['#007AFF', '#2ECE76', '#FFAB1A', '#FF5C39', '#6474FC'];

const ClassIcon = () => {
  const color = randomColors[Math.floor(Math.random() * randomColors.length)];

  return (
    <div style={{ height: 48, width: 48, backgroundColor: color, borderRadius: 6 }} className='d-flex justify-content-center align-items-center'>
      <BiGroup size={24} color='white' />
    </div>
  );
};

const fetcher = (studentId) => {
  return query('p_SACHSO_Classes_GetJoinedClasses_ByStudentId', { studentId });
};

export default withAuthenticator(({ loggedInUser }) => {
  const history = useHistory();

  const { data, isLoading } = useQuery(['student', loggedInUser?.id], () => fetcher(loggedInUser?.id));

  return (
    <div>
      <List
        loading={isLoading}
        itemLayout='horizontal'
        dataSource={data}
        renderItem={(item) => (
          <List.Item
            key={item.id}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              history.push(`/lms/student/classes/${item.id}`);
            }}
          >
            <List.Item.Meta avatar={<ClassIcon />} title={`${item.className} (${item.code})`} description={`GV: ${item.teacherName}`} />
            <BiChevronRight size={20} />
          </List.Item>
        )}
      />
    </div>
  );
});
